const types = {
  STORE_CUSTOMER_CODE_SUCCESS: '@drivex/session/STORE_CUSTOMER_CODE_SUCCESS',
  STORE_PREFERRED_LANGUAGE_SUCCESS: '@drivex/session/STORE_PREFERRED_LANGUAGE_SUCCESS',
  LOG_OUT_STARTED: '@drivex/session/LOG_OUT_STARTED',
  LOG_OUT_SUCCESS: '@drivex/session/LOG_OUT_SUCCESS',
  LOG_OUT_FAILURE: '@drivex/session/LOG_OUT_FAILURE',
  STORE_UNSUPPORTED_BROWSER: '@drivex/session/UNSUPPORTED_BROWSER',
  STORE_USE_NATIVE_CAMERA: '@drivex/session/STORE_USE_NATIVE_CAMERA',
  STORE_DEVICE_INFO: '@drivex/session/STORE_DEVICE_INFO',
  START_RECORDING_USER_SESSION: '@drivex/session/START_RECORDING_USER_SESSION',
  SET_PUBLIC_USER_TRACKING_INFO: '@drivex/session/SET_PUBLIC_USER_TRACKING_INFO'
};

export { types };
